export default "__VITE_ASSET__80bc4394__"